import { Provider } from 'react-redux';
import { signup } from './stores/sign-up/sign-up-reducer';
import { route } from './stores/route/route-reducer';
import { Route, IndexRoute, Router, browserHistory } from 'react-router';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import thunk from 'redux-thunk';
import SignUpRouter from './components/signup/signup-container';
import SignUp from './components/signup/signup';

require('../less/main.less'); // FOR WEBPACK

const createStoreWithMiddleware = compose(applyMiddleware(thunk))(createStore);
const reducer = combineReducers({
  signup,
  route,
});

const store = createStoreWithMiddleware(reducer);

// Needed for onTouchTap
// Can go away when react 1.0 release
// Check this repo:
// https://github.com/zilverline/react-tap-event-plugin
injectTapEventPlugin();

/* jshint ignore:start */
  /* jshint ignore:start */
ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/signup" component={SignUpRouter}>
        <IndexRoute component={SignUp} />
      </Route>
    </Router>
  </Provider>,
  document.getElementById('app')
);

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/signup.prod.jsx